import { invoke } from '@shared/easyfy.decorators';
import { globalEvent } from '@shared/easyfy.core';

@invoke
export class TabsProductListComponent {
  onInit() {
    globalEvent({
      type: 'click',
      event: {
        event: 'select-tab',
        callback: TabsProductListComponent.selectTab,
      },
    });

    globalEvent({
      type: 'keydown',
      event: {
        event: 'select-tab',
        callback: TabsProductListComponent.handleKeydown,
      },
    });

    TabsProductListComponent.initTab();
  }

  static selectTab(e: Event) {
    e.preventDefault();
    const element = e.target;
    if (!(element instanceof HTMLElement)) return;
    const targetId = element.dataset.target;
    if (!targetId) return;

    const navElement = element.closest<HTMLElement>('.nav-item');
    const parentElement = element.closest('.nav-tabs');
    if (!parentElement || !navElement) return;

    const selectedTab = parentElement.querySelector(':scope > .nav-item.active');
    if (selectedTab === navElement) {
      return;
    }

    if (selectedTab) {
      selectedTab.classList.remove('active');
      selectedTab.setAttribute('aria-selected', 'false');
      selectedTab.setAttribute('tabindex', '-1');
    }

    navElement.classList.add('active');
    navElement.setAttribute('aria-selected', 'true');
    navElement.removeAttribute('tabindex');

    navElement.focus();

    const component = navElement.closest('[data-container="tabs-list-component"]');
    if (!component) return;

    const selectedTabContent = component.querySelector(`.tab-pane.active`);
    if (selectedTabContent) {
      selectedTabContent.classList.remove('active');
      selectedTabContent.setAttribute('hidden', '');
      selectedTabContent.setAttribute('inert', '');
    }

    const tabTarget = component.querySelector(`#${targetId}`);
    if (tabTarget) {
      tabTarget.classList.add('active');
      tabTarget.removeAttribute('hidden');
      tabTarget.removeAttribute('inert');
    }
  }

  static handleKeydown(e: KeyboardEvent) {
    const element = e.target;
    if (!(element instanceof HTMLElement)) return;

    const parentElement = element.closest('.nav-tabs');
    if (!parentElement) return;

    const tabs = Array.from(parentElement.querySelectorAll('.nav-item'));
    const currentIndex = tabs.indexOf(element);

    let targetTab: Element | null = null;

    switch (e.key) {
      case 'ArrowLeft':
        e.preventDefault();
        targetTab = tabs[currentIndex - 1] || tabs[tabs.length - 1];
        break;
      case 'ArrowRight':
        e.preventDefault();
        targetTab = tabs[currentIndex + 1] || tabs[0];
        break;
      case 'Home':
        e.preventDefault();
        targetTab = tabs[0];
        break;
      case 'End':
        e.preventDefault();
        targetTab = tabs[tabs.length - 1];
        break;
      default:
        return;
    }

    if (targetTab instanceof HTMLElement) {
      targetTab.click();
    }
  }

  static initTab() {
    const hash = window.location.hash;
    if (!hash) return;
    const element = document.querySelector(`[href="${hash}"]`);
    if (element instanceof HTMLElement) {
      element.click();
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }
}
